import { render } from "./CabinetSlider.vue?vue&type=template&id=00ee2f8e&scoped=true"
import script from "./CabinetSlider.vue?vue&type=script&lang=js"
export * from "./CabinetSlider.vue?vue&type=script&lang=js"

import "./CabinetSlider.vue?vue&type=style&index=0&id=00ee2f8e&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ee2f8e"]])

export default __exports__